import { render, staticRenderFns } from "./Manager2Index.vue?vue&type=template&id=395bccca&"
import script from "./js/man2Index.js?vue&type=script&lang=js&"
export * from "./js/man2Index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports